import { z } from 'zod';

export const noLeadingSpace = (fieldName: string) =>
  z
    .string()
    .min(1, `${fieldName} is required`)
    .refine((val) => !/^\s+/.test(val), {
      message: `${fieldName} cannot start with spaces`,
    });
